var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 6C4.23858 6 2 8.23858 2 11V17C2 19.7614 4.23858 22 7 22H17C19.6776 22 21.8636 19.8953 21.9939 17.25H17.5C15.7051 17.25 14.25 15.7949 14.25 14C14.25 12.2051 15.7051 10.75 17.5 10.75H21.9939C21.8636 8.10472 19.6776 6 17 6H7ZM17.5 12.25H22V15.75H17.5C16.5335 15.75 15.75 14.9665 15.75 14C15.75 13.0335 16.5335 12.25 17.5 12.25ZM6 16.75C5.58579 16.75 5.25 17.0858 5.25 17.5C5.25 17.9142 5.58579 18.25 6 18.25H12C12.4142 18.25 12.75 17.9142 12.75 17.5C12.75 17.0858 12.4142 16.75 12 16.75H6ZM17.5 13.25C17.0858 13.25 16.75 13.5858 16.75 14C16.75 14.4142 17.0858 14.75 17.5 14.75H17.7C18.1142 14.75 18.45 14.4142 18.45 14C18.45 13.5858 18.1142 13.25 17.7 13.25H17.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4883 4.99302C18.7672 3.00165 16.6611 1.716 14.4418 2.1729L5.84113 3.94363C4.04475 4.31348 2.58936 5.4977 1.82812 7.06305C3.01559 5.5053 4.89071 4.5 7.00064 4.5H17.0006C17.8818 4.5 18.722 4.67534 19.4883 4.99302Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletActive);
export default __webpack_public_path__ + "static/media/wallet-active.74761208f277f710f93d9cc4ec237084.svg";
export { ForwardRef as ReactComponent };